window._ = require('lodash');
import { Validator } from 'vee-validate';


/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */



try {
	window.$ = window.jQuery = require('jquery');

	require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min.js');
	require('./mixin.js');

	//require('bootstrap');

	window.moment = require('moment-timezone');
} catch (e) {
	console.warn(e);
}





